import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import directive from './utils/change';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.directive("change", directive);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
